// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_LogicExpr_AST from "../Data.LogicExpr.AST/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var renderString = {
    render: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var renderB4 = {
    render: Data_LogicValues_B4["short"]
};
var render = function (dict) {
    return dict.render;
};
var renderEither = function (dictRender) {
    var render1 = render(dictRender);
    return function (dictRender1) {
        return {
            render: Data_Either.either(render1)(render(dictRender1))
        };
    };
};
var renderExpr = function (dictRender) {
    return {
        render: Data_LogicExpr_AST.renderWith(render(dictRender))
    };
};
var renderValueExpr = function (dictRender) {
    var renderEither1 = renderEither(dictRender);
    return function (dictRender1) {
        return {
            render: (function () {
                var $16 = render(renderExpr(renderEither1(dictRender1)));
                return function ($17) {
                    return $16(unwrap($17));
                };
            })()
        };
    };
};
export {
    render,
    renderB4,
    renderString,
    renderEither,
    renderExpr,
    renderValueExpr
};
//# sourceMappingURL=index.js.map
